// extracted by mini-css-extract-plugin
export default {"modal":"GetterAddressModal_modal__-Kg+t"};